"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Main = {
    default: "https://menu.cdn.bitcoindotcom.net/uni/dist/assets/images/logo_black.png",
    contrast: "https://menu.cdn.bitcoindotcom.net/uni/dist/assets/images/logo_white.png"
};
var Card = {
    default: "https://menu.cdn.bitcoindotcom.net/uni/dist/assets/images/logos/card_black.png",
    contrast: "https://menu.cdn.bitcoindotcom.net/uni/dist/assets/images/logos/card_white.png"
};
var Logos = { Main: Main, Card: Card };
exports.default = Logos;
//# sourceMappingURL=logos.js.map